import TextInput from "Components/TextInput/TextInput";
import { Button } from "Components/ui/button";
import { Separator } from "Components/ui/separator";
import google from "../../Assets/Images/google.png";
import AuthCard from "../../Components/AuthCard/AuthCard";
import AuthLayout from "../../Components/AuthLayout/AuthLayout";
import apple from "../../Assets/Images/apple.png";
import facebook from "../../Assets/Images/facebook.png";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSignIn, useSignUp, useUser } from "@clerk/clerk-react";

function LoginLink() {
  const { signIn } = useSignIn();
  const { isSignedIn } = useUser();
  const { isLoaded, signUp } = useSignUp();
  const [timing, setTiming] = useState(30);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      const signedIn = await signIn.create({
        identifier: data.email,
        strategy: "email_link",
        redirectUrl: `${process.env.REACT_APP_LOCAL_API}/`,
      });

      setLoading(false);
      if (signIn?.status == "needs_first_factor") {
        setStep(2);
        if (step == 2) {
          setTiming(30);
        }
      } else {
        if (signIn?.status == "complete") {
          window.location.href = "/";
        } else {
          setError("Something went wrong");
        }
      }
    } catch (e) {
      setLoading(false);
      setError(e);
    }
  };

  useEffect(() => {
    if (timing > 0 && step == 2) {
      setTimeout(() => {
        setTiming(timing - 1);
      }, 1000);
    }
  }, [timing, step]);
  const navigate = useNavigate();
  const [data, setData] = useState({});

  useEffect(() => {
    if (isSignedIn && isLoaded) {
      navigate("/");
    }
  }, [isSignedIn, isLoaded]);

  return (
    <AuthLayout>
      {step == 1 ? (
        <div className="flex justify-center mt-[45vh] translate-y-[-50%] h-[60vh] ">
          <form
            className="flex flex-col gap-6 w-full max-w-[30rem]"
            onSubmit={(e) => handleSubmit(e)}
          >
            <div className="text-2xl font-N_Medium">
              Login into your account
            </div>
            <TextInput
              label="Email"
              required={true}
              placeholder="Enter your email"
              type="email"
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />

            {error && <div className="text-red text-sm">{error.message}</div>}
            <Button
              type="submit"
              className="p-[1.3rem]"
              disabled={!isLoaded || loading}
            >
              {loading ? "Sending" : "Send Link"}
            </Button>
            <div
              className="w-fit mx-auto text-center text-primary text-sm font-N_Medium hover:underline cursor-pointer"
              onClick={() => navigate("/auth/login")}
            >
              Back
            </div>
            <div className="text-center text-grey text-sm mt-[-0.5rem]  ">
              Don't have an account?{" "}
              <span
                className="ml-1 text-primary hover:underline cursor-pointer font-N_Medium"
                onClick={() => navigate("/auth/login?tab=Register")}
              >
                Sign up
              </span>
            </div>
            <div className="text-grey text-sm mt-5 flex items-center gap-4  ">
              Or continue with
              <Separator className="bg-grey flex-1" />
            </div>
            <div className=" flex items-center gap-4  ">
              <div className="flex justify-center border border-grey p-3 rounded-lg cursor-pointer flex-1">
                <img src={google} alt="google" className="w-6 h-6" />
              </div>
              <div className="flex justify-center border border-grey p-3 rounded-lg cursor-pointer flex-1">
                <img src={apple} alt="apple" className="w-6 h-6" />
              </div>{" "}
              <div className="flex justify-center border border-grey p-3 rounded-lg cursor-pointer flex-1">
                <img src={facebook} alt="facebook" className="w-6 h-6" />
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div className="flex justify-center mt-[45vh] translate-y-[-50%] h-[60vh] items-center flex-col gap-6 w-full">
          <div className="text-center text-white-FOREGROUND text-sm ">
            Link sent to {data.email}, please check your email.
          </div>
          <div className="text-center text-grey text-sm ">
            Didn't receive the link?
            <span
              className="ml-1 text-primary hover:underline cursor-pointer font-N_Medium"
              style={{
                color: `${timing == 0 ? "var(--primary)" : "var(--grey)"}`,
                pointerEvents: `${timing == 0 ? "all" : "none"}`,
              }}
              onClick={(e) => {
                if (timing == 0) {
                  handleSubmit(e);
                }
              }}
            >
              {timing == 0 ? "Resend Link" : `Resend Link in ${timing} seconds`}
            </span>
          </div>
          <div
            className="w-fit mx-auto text-center text-primary text-sm font-N_Medium hover:underline cursor-pointer"
            onClick={() => navigate("/auth/login?tab=Login")}
          >
            Back
          </div>
        </div>
      )}
    </AuthLayout>
  );
}

export default LoginLink;
